import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {
    static targets = ["searchResult", "searchItem"];

    connect() {
        console.log("log from parcel-select controller");

    }

    requestParcelSearch(e) {
        clearTimeout(delayTimer);
        let component = this;
        delayTimer = setTimeout(function () {
            const resultsArea = component.searchResultTarget;
            resultsArea.classList.remove("hidden")
            if (component.searchItemTarget.value.length > 2) {
                fetch('/search/parcel_query.html?search='
                    + encodeURIComponent(component.searchItemTarget.value) +
                    "&limit=" + encodeURIComponent((e.target.dataset.limit || 5)),
                )
                    .then(response => {
                        return response.text();
                    })
                    .then(html => {
                        if (html.length > 0) {
                            resultsArea.querySelector(".searching-interim").classList.add("hidden");
                            resultsArea.querySelector(".results-list").innerHTML = html;
                            resultsArea.querySelector(".query-gis").classList.remove("hidden");
                        } else {
                            resultsArea.querySelector(".searching-interim").classList.add("hidden");
                            resultsArea.querySelector(".query-gis").classList.remove("hidden");
                        }

                    });
            } else {
                resultsArea.classList.add("hidden")
            }
        }, 800)

    }

    queryGisServer(e) {
        e.preventDefault();
        let component = this;
        const resultsArea = component.searchResultTarget;
        resultsArea.querySelector(".searching-interim").classList.remove("hidden");
        fetch('/search/parcel_gis_query.html?search=' + encodeURIComponent(component.searchItemTarget.value))
            .then(response => {
                return response.text();
            })
            .then(html => {
                if (html.length > 0) {
                    resultsArea.querySelector(".results-list").innerHTML = html;
                    resultsArea.querySelector(".searching-interim").classList.add("hidden");
                    resultsArea.querySelector(".query-gis").classList.add("hidden");
                } else {
                    resultsArea.querySelector(".searching-interim").classList.add("hidden");
                    resultsArea.querySelector(".no-results").classList.remove("hidden");
                }

            });
    }

    shellParcel(e) {
        e.preventDefault();
        let component = this;
        const resultsArea = component.searchResultTarget;
        resultsArea.querySelector(".searching-interim").classList.remove("hidden");
        fetch('/parcels/shell_builder?identifier=' + encodeURIComponent(component.searchItemTarget.value))
            .then(response => {
                return response.text();
            })
            .then(html => {
                if (html.length > 0) {
                    resultsArea.querySelector(".results-list").innerHTML = html;
                    resultsArea.querySelector(".searching-interim").classList.add("hidden");
                    resultsArea.querySelector(".query-gis").classList.add("hidden");
                }
            });
    }

    selectParcel(e) {
        const parcelSelectContainer = e.target.closest(".parcel-select-container");
        const parcelSelectedArea = parcelSelectContainer.querySelector(".selected-parcels").querySelector("ul");
        const chosenParcel = e.currentTarget;
        if (chosenParcel.classList.contains("selected")) {
            e.stopImmediatePropagation();
            return;
        }

        const chosenParcelId = chosenParcel.id;
        const resultsArea = this.searchResultTarget;
        const alternateAddresses = this.parseAlternateAddresses(chosenParcel.dataset.alternateAddresses);
        const existingParcel = this.findExistingParcel(chosenParcelId, parcelSelectedArea);

        if (existingParcel) {
            if (alternateAddresses.length === 0) {
                window.alert("This parcel has already been added.");
                e.stopImmediatePropagation();
                e.preventDefault();
                return;
            }
            if (!window.confirm("This parcel is already added. It has alternate addresses — do you want to add it again with a different address?")) {
                e.stopImmediatePropagation();
                e.preventDefault();
                return;
            }
        }

        const template = parcelSelectedArea.querySelector(".parcel-assignment-template") || parcelSelectedArea.querySelector(".assignment-template")?.closest("li");
        const timeStamp = Date.now();
        const parcelSelectArea = e.target.closest(".popup-form");
        const newAssignment = this.cloneAssignment(template, timeStamp, chosenParcelId);

        if (existingParcel) {
            chosenParcel.dataset.parcelId = chosenParcelId;
            chosenParcel.id = `${chosenParcelId}_${timeStamp}`;
        }
        chosenParcel.dataset.assignmentKey = timeStamp;

        parcelSelectedArea.appendChild(chosenParcel);
        chosenParcel.classList.add("moved");
        if (newAssignment) {
            newAssignment.dataset.assignmentKey = timeStamp;
            parcelSelectedArea.appendChild(newAssignment);
        }
        if (alternateAddresses.length > 0) {
            chosenParcel.dataset.alternateAddresses = JSON.stringify(alternateAddresses);
        }
        resultsArea.classList.add("hidden");
        const event = new Event("click");
        parcelSelectedArea.dispatchEvent(event);
        if (parcelSelectArea !== null) {
            parcelSelectArea.classList.remove("editing");
        }
    }

    deleteParcel(e) {
        const parcelToRemove = e.target.closest(".result-parcel");
        const assignmentKey = parcelToRemove.dataset.assignmentKey;
        const chosenParcelId = parcelToRemove.dataset.parcelId || parcelToRemove.id;
        const parcelSelectContainer = e.target.closest(".parcel-select-container");
        const parcelSelectedArea = parcelSelectContainer.querySelector(".selected-parcels").querySelector("ul");
        parcelSelectedArea.removeChild(parcelToRemove);
        if (assignmentKey) {
            const assignment = parcelSelectedArea.querySelector(`li[data-assignment-key="${assignmentKey}"]`);
            if (assignment) {
                assignment.remove();
            }
        } else {
            Array.from(parcelSelectContainer
                .querySelectorAll("input"))
                .map(function (input) {
                    if (input.value === chosenParcelId) {
                        input.remove();
                    }
                })
        }
    }

    cloneAssignment(template, timeStamp, parcelId) {
        if (!template) {
            return null;
        }
        const clone = template.cloneNode(true);
        clone.classList.remove("parcel-assignment-template");
        clone.classList.add("hidden");
        clone.querySelectorAll("input").forEach((input) => {
            if (input.id) {
                input.id = input.id.replace(/_\d+_/, `_${timeStamp}_`);
            }
            if (input.name) {
                input.name = input.name.replace(/\[\d+\]/, `[${timeStamp}]`);
            }
            if (input.name && (input.name.includes("[parcel_id]") || input.name === "parcel_id")) {
                input.value = parcelId;
                input.dataset.parcelId = parcelId;
            } else if (input.name && input.name.includes("[parcel_alternate_address_id]")) {
                input.value = "";
                input.dataset.parcelId = parcelId;
            } else if (input.name && input.name.includes("[_destroy]")) {
                input.value = "";
            }
        });
        return clone;
    }

    findExistingParcel(parcelId, parcelSelectedArea) {
        const existingInHiddenArea = Array.from(parcelSelectedArea.querySelectorAll("li.moved")).find(
            (el) => (el.dataset.parcelId || el.id) === parcelId
        );
        const applicationParcels = document.querySelector(".application-parcels")?.querySelector("ul");
        const existingInVisibleArea = applicationParcels
            ? Array.from(applicationParcels.querySelectorAll("li")).find(
                  (el) => (el.dataset.parcelId || el.id) === parcelId
              )
            : null;
        return existingInHiddenArea || existingInVisibleArea;
    }

    parseAlternateAddresses(data) {
        if (!data) {
            return [];
        }
        try {
            const parsed = JSON.parse(data);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    }
}
